var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Icon from '@alife/next-icon';
import classnames from 'classnames';
var NextDropDownIcon = function (props) { return React.createElement(Icon, { type: "arrow-down", className: classnames({ 'icon-state': true, active: props.isActive }), size: "small" }); };
var NextSelectIcon = function (props) { return React.createElement(Icon, { type: "select", className: classnames({ active: props.isActive }), size: "small" }); };
var Select = (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, defaultValue = _a.defaultValue, _b = _a.options, options = _b === void 0 ? [] : _b;
        var firstOption = options[0] || {};
        _this.state = {
            opened: false,
            selectedValue: defaultValue || firstOption.value || ''
        };
        _this.toggleOpen = _this.toggleOpen.bind(_this);
        _this.clickOption = _this.clickOption.bind(_this);
        return _this;
    }
    Select.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({
                selectedValue: nextProps.value
            });
        }
    };
    Select.prototype.toggleOpen = function (opened) {
        var _this = this;
        if (opened === void 0) { opened = !this.state.opened; }
        return function () {
            _this.setState({ opened: opened });
        };
    };
    Select.prototype.clickOption = function (o) {
        if (this.state.selectedValue !== o.value) {
            this.props.onChange(o.value);
        }
        this.setState({
            selectedValue: o.value
        });
        this.toggleOpen(false)();
    };
    Select.prototype.render = function () {
        var _this = this;
        var _a = this.props, options = _a.options, className = _a.className, SelectIcon = _a.SelectIcon, DropdownIcon = _a.DropdownIcon;
        var _b = this.state, opened = _b.opened, selectedValue = _b.selectedValue;
        var item = options.find(function (i) { return i.value === selectedValue; }) || { label: '' };
        return (React.createElement("div", { ref: function (ref) { return _this.self = ref; }, className: classnames("simple-select", className), onClick: this.toggleOpen(), onBlur: this.toggleOpen(false), tabIndex: 0 },
            React.createElement("div", { className: "inner" },
                item.label,
                React.createElement(DropdownIcon, { isActive: opened })),
            React.createElement("div", { className: classnames('dropdown', { opened: opened }) }, React.createElement("ul", { className: "list" }, options.map(function (opt, i) { return (React.createElement(Option, { key: i, option: opt, isSelected: opt.value === selectedValue, onClick: _this.clickOption, SelectIcon: SelectIcon })); })))));
    };
    Select.defaultProps = {
        DropdownIcon: NextDropDownIcon,
        SelectIcon: NextSelectIcon,
    };
    return Select;
}(React.Component));
function Option(props) {
    var option = props.option, isSelected = props.isSelected, onClick = props.onClick, SelectIcon = props.SelectIcon;
    var disabled = option.disabled;
    return (React.createElement("li", { className: classnames({ 'selected': isSelected, disabled: disabled }), onClick: function () { return !disabled && onClick(option); } },
        React.createElement(SelectIcon, { isActive: isSelected }),
        option.label));
}
export default Select;

//# sourceMappingURL=index.js.map
